<template>
  <div class="flex items-center h-full">
    <toggle-button
      :value="params.data.actionData.toggle"
      :color="{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}"
      @change="handleChange"
    />
  </div>
</template>
<script>
import { Clienttoogle } from '@/api/client'
// import { Delete_Leads } from '@/api/leads'
import { mapActions } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: 'ToggleActions',
  components: {
    ToggleButton
  },
  props: {
    // localValue: actionData,
  },
  mounted () {
    this.action = this.params.data.actionData
    this.toggle = this.params.data.actionData.toggle
  },
  data () {
    return {
      action: {},
      toggle: null
    }
  },
  methods: {
    ...mapActions([
      'SET_CLIENT_DELETE_ID',
      'SET_VIEW_CLIENT_SIDEBAR',
      'SET_VIEW_CLIENT_SIDEBAR_DATA',
      'SET_CLIENT_TOGGLE_DATA'
    ]),
    async handleChange () {
      
      try {
        const client_users_id = this.params.data.basic_details.client_users_id
        

        const togglePayload = {
          active_user: this.params.data.actionData.toggle ? 0 : 1,
          client_user_id: this.params.data.basic_details.client_users_id
        }
        
        await Clienttoogle(togglePayload)
        
        const storePayload = {
          row_details: this.params.data,
          toggle: !this.params.data.actionData.toggle
        }
        this.SET_CLIENT_TOGGLE_DATA(storePayload)
        const msg = !this.params.data.actionData.toggle ? 'Student activated successfully' : 'Student deactivated successfully'
        this.$vs.notify({
          title: 'Success',
          text: msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e.data.message,
          ...this.warnProp()
        })
      }
    }
  }
}
</script>
